<div class="upload-page-container">
  <!-- Slim Sub-header Navigation -->
  <div class="navbar-sub-header" [ngClass]="{ 'disable-content': menuOpened }"
    style="display: flex; align-items: center;">
    <a (click)="goBack()" class="header-back-btn cursorPointer"
      [style.opacity]="(uploadInProgress || archiveInProgress) ? '0.5' : '1'"
      [style.pointer-events]="(uploadInProgress || archiveInProgress) ? 'none' : 'auto'"
      style="margin-right: 12px;"
      title="Back">
      <span class="material-symbols-outlined">arrow_back</span>
    </a>
    <a [routerLink]="(uploadInProgress || archiveInProgress) ? null : '/home'" href="javascript:void(0)" class="navbar-logo-link"
      [style.pointer-events]="(uploadInProgress || archiveInProgress) ? 'none' : 'auto'">
      <img src="../../../assets/login/header-logo.png" class="navbar-logo-img" alt="Logo" />
    </a>
    <h2 class="card-title-main font-weight-bold"
      style="font-size: 1.25rem; margin: 0; text-transform: uppercase; letter-spacing: 0.5px; margin-left: 20px;">
      {{ edit ? 'Edit Archive Project' : 'Archive Your Project' }}
    </h2>
  </div>

  <!-- CREATE MODE BLOCK -->
  @if (!edit) {
  <div class="container-fluid center" [ngClass]="{ 'disable-content': menuOpened }">
    <div class="modern-card single-form-card">
      <div class="modern-grid-layout">

        <!-- COLUMN 1: Form Column (Left on desktop) -->
        <div class="form-column">
          <!-- General Information Card -->
          <div class="form-section">
            <div class="card-header-block">
              <h3 class="card-title-main">General Information</h3>
            </div>

            <form [formGroup]="projectForm" class="form-card-flow">
              <div class="modern-form-row">
                <div class="modern-form-group">
                  <label class="form-label-styled">Title *</label>
                  <input class="modern-input-field" formControlName="title" type="text" placeholder="Enter title" />
                  @if (projectForm.get('title').hasError('required') && projectForm.get('title').touched) {
                  <div class="text-danger font-12 mt-1">Title is required.</div>
                  }
                </div>

                <div class="modern-form-group" style="position: relative;">
                  <label class="form-label-styled">Client Name *</label>
                  <input class="modern-input-field" formControlName="client_name" type="text"
                    placeholder="Enter client name" (input)="onInput($any($event.target).value)"
                    (click)="toggleSuggestions()" />
                  @if (projectForm.get('client_name').hasError('required') && projectForm.get('client_name').touched) {
                  <div class="text-danger font-12 mt-1">Client name is required.</div>
                  }

                  @if (showSuggestions && filteredSuggestions.length > 0) {
                  <div id="suggestions" class="suggestions">
                    @for (suggestion of filteredSuggestions; track suggestion) {
                    <div class="suggestion-item" (click)="selectSuggestion(suggestion)">
                      {{ suggestion }}
                    </div>
                    }
                  </div>
                  }
                </div>
              </div>

              <div class="modern-form-group">
                <div class="d-flex justify-content-between align-items-center mb-1">
                  <label class="form-label-styled mb-0">Description</label>
                  <span class="font-12 text-muted" [class.text-danger]="(projectForm.get('description')?.value?.length || 0) >= 1000">
                    {{ projectForm.get('description')?.value?.length || 0 }}/1000
                  </span>
                </div>
                <textarea class="modern-input-field modern-textarea-field" formControlName="description"
                  maxlength="1000" rows="5" placeholder="Write description here..."></textarea>
                @if (projectForm.get('description')?.hasError('maxlength')) {
                <div class="text-danger font-12 mt-1">Description cannot exceed 1000 characters.</div>
                }
              </div>
            </form>
          </div>

          <!-- Collection Settings Card (Moved from top header) -->
          <div class="form-section separator-top">
            <div class="card-header-block">
              <h3 class="card-title-main">Collection Settings</h3>
            </div>

            <div class="settings-grid">
              <!-- Collection Type Toggle -->
              <div class="setting-item-box">
                <span class="setting-title">Collection Type</span>
                <div class="toggle-group-inline">
                  <span class="toggle-text-label"
                    [class.active-label]="selectedCollectionType === 'Public'">Public</span>
                  <div class="onoffswitch">
                    <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox" id="private-public"
                      [checked]="selectedCollectionType === 'Private'" (change)="onChangeCollectionType($event)" />
                    <label class="onoffswitch-label" for="private-public">
                      <span class="onoffswitch-switch"></span>
                    </label>
                  </div>
                  <span class="toggle-text-label"
                    [class.active-label]="selectedCollectionType === 'Private'">Private</span>
                </div>
              </div>

              <!-- Project Type Toggle -->
              <div class="setting-item-box">
                <span class="setting-title">Project Type</span>
                <div class="toggle-group-inline">
                  <span class="toggle-text-label"
                    [class.active-label]="selectedProjectType === 'Company'">Company</span>
                  <div class="onoffswitch">
                    <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox" id="projectType"
                      [checked]="selectedProjectType === 'Reference'" (change)="onChangeCompanyProductType($event)" />
                    <label class="onoffswitch-label" for="projectType">
                      <span class="onoffswitch-switch"></span>
                    </label>
                  </div>
                  <span class="toggle-text-label"
                    [class.active-label]="selectedProjectType === 'Reference'">Reference</span>
                </div>
              </div>

              <!-- Agreement Toggle -->
              <div class="setting-item-box">
                <span class="setting-title">Agreement</span>
                <div class="toggle-group-inline">
                  <span class="toggle-text-label" [class.active-label]="selectedAgreementType === 'NDA'">NDA</span>
                  <div class="onoffswitch">
                    <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox" id="nda"
                      [checked]="selectedAgreementType === 'Non-NDA'" (change)="onChangeNdaType($event)" />
                    <label class="onoffswitch-label" for="nda">
                      <span class="onoffswitch-switch"></span>
                    </label>
                  </div>
                  <span class="toggle-text-label"
                    [class.active-label]="selectedAgreementType === 'Non-NDA'">Non-NDA</span>
                </div>
              </div>

              <!-- Company Tabs Selection -->
              <div class="setting-item-box">
                <span class="setting-title">Company</span>
                <div class="segmented-tabs-wrapper">
                  <button type="button" class="segmented-tab-btn" [class.active]="companyNameTag === 'square pixel'"
                    (click)="onChangeCompanyTag('square pixel')">
                    Square Pixel
                  </button>
                  <button type="button" class="segmented-tab-btn" [class.active]="companyNameTag === 'ink in caps'"
                    (click)="onChangeCompanyTag('ink in caps')">
                    Ink in Caps
                  </button>
                </div>
              </div>

              <!-- File Category Type Selector -->
              <div class="setting-item-box full-width">
                <span class="setting-title">Category Type</span>
                <div class="modern-dropdown-wrapper dropdown">
                  <button class="btn dropdown-toggle modern-dropdown-btn" type="button" id="dropdownMenuButton"
                    data-toggle="dropdown" aria-expanded="false">
                    <span class="text-capitalize drag-file-type">{{ selectedTags }}</span>
                    <i class="fa fa-caret-down"></i>
                  </button>
                  <ul class="dropdown-menu modern-dropdown-menu" aria-labelledby="dropdownMenuButton">
                    @for ( tag of companyTagsArray[1].companyTags; track tag ) {
                    <li class="dropdown-item modern-dropdown-item text-capitalize" (click)="addCompanyRelatedTags(tag)">
                      {{ tag }}
                    </li>
                    }
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Additional Files Card -->
          <div class="form-section separator-top">
            <div class="card-header-block d-flex align-items-center justify-content-between">
              <h3 class="card-title-main mb-0">Additional Media Uploads</h3>
              <span class="badge badge-pill font-12 px-2 py-1" style="background: rgba(101, 101, 172, 0.2); color: var(--text-primary, #fff); border: 1px solid var(--border-color, rgba(255,255,255,0.15)); font-weight: 600;">
                Total Additional Files: {{ ImagefilesResponseUrl.length }}
              </span>
            </div>

            <div class="additional-files-grid">
              <label class="additional-add-btn" [class.disabled]="!selectedFile || uploadInProgress" title="Add additional files"
                [style.pointer-events]="(!selectedFile || uploadInProgress) ? 'none' : 'auto'"
                [style.opacity]="(!selectedFile || uploadInProgress) ? '0.5' : '1'">
                <input type="file" (change)="onClickAddImage($event)" multiple [disabled]="!selectedFile || uploadInProgress"
                  style="display: none" />
                <img src="../../../assets/icons 6/multiple-icon.png" width="20" height="20" />
                <span class="additional-upload-text">
                  {{ uploadInProgress ? 'Please wait for main file upload...' : (!selectedFile ? 'Upload main file first' : 'Click to upload additional assets') }}
                </span>
              </label>

              @for (mediaUrl of ImagefilesResponseUrl; track mediaUrl._id || mediaUrl.fileName || i; let i = $index) {
              <div class="additional-file-pill">
                <button type="button" class="close-button" (click)="onClickDeleteImage(mediaUrl.fileName)">
                  <img src="../../../assets/cross_icon.svg" />
                </button>

                @if (mediaUrl.type === 'image' || mediaUrl.type === 'document') {
                <img class="additional-preview-thumb" [src]="mediaUrl.fileUrl" />
                }
                @if (mediaUrl.type === 'video') {
                <video class="additional-preview-thumb" [src]="mediaUrl.fileUrl"></video>
                }
              </div>
              }
            </div>

            @if (loading) {
            <div class="text-center py-1">
              <p class="font-12 mb-0 text-muted"><i class="fa fa-circle-o-notch fa-spin"></i> Uploading...</p>
            </div>
            }
          </div>

          <!-- Tagging & Group Organization Card -->
          <div class="form-section separator-top">
            <div class="card-header-block">
              <h3 class="card-title-main">Tagging & Organization</h3>
            </div>

            <div class="form-card-flow">
              <!-- Add to Collection -->
              <div class="modern-form-group">
                <label class="form-label-styled">Add to Collection</label>
                <div class="d-flex align-items-center flex-wrap gap-2">
                  <button type="button"
                    class="btn-upload-secondary btn-add-new-collection d-flex align-items-center gap-1"
                    data-toggle="modal" data-target="#staticBackdrop">
                    <img src="../../../assets/plus_icon.svg" width="16" height="20" />
                    <span>New</span>
                  </button>

                  <div class="modern-dropdown-wrapper dropdown flex-grow-1" style="max-width: 180px;">
                    <button class="btn dropdown-toggle modern-dropdown-btn" type="button" id="dropdownMenuCollection"
                      data-toggle="dropdown" aria-expanded="false">
                      <span class="text-capitalize text-truncate">{{ selectedCollection || "Existing" }}</span>
                      <i class="fa fa-caret-down"></i>
                    </button>
                    <ul class="dropdown-menu modern-dropdown-menu" aria-labelledby="dropdownMenuCollection"
                      style="max-height: 180px; overflow-y: auto;">
                      @for (group of existingCollections; track group; let i = $index) {
                      @if ( group.isPublic === (selectedCollectionType === 'Public') ) {
                      <li class="dropdown-item modern-dropdown-item text-capitalize" (click)="selectedPlayList(group)">
                        {{ group.title }}
                      </li>
                      }
                      }
                    </ul>
                  </div>

                  @if (customTags && collectionTags.length > 0) {
                  <span class="modern-tag-badge"
                    style="background-color: var(--bg-active); border-color: var(--border-light); padding: 4px 8px; font-size: 0.8rem;">
                    <span>{{ collectionTags }}</span>
                    <button type="button" class="btn-remove-tag" (click)="removeSelected(collectionTags)">
                      <img src="../../../assets/close1.png" />
                    </button>
                  </span>
                  }
                </div>
              </div>

              <!-- Primary Auto-generated Tags -->
              <div class="modern-form-group">
                <label class="form-label-styled">Primary tags</label>
                <div class="tags-container d-flex flex-wrap gap-1">
                  @for (tag of primaryTags; track tag; let i = $index) {
                  <span class="modern-tag-badge primary-tag-badge">
                    <span>{{ tag }}</span>
                    @if (i > 3) {
                    <button type="button" class="btn-remove-tag" (click)="removePrimaryTag(i)">
                      <img src="../../../assets/close1.png" />
                    </button>
                    }
                  </span>
                  }
                </div>
              </div>

              <!-- Custom Tags -->
              <div class="modern-form-group">
                <label class="form-label-styled">Custom Tags</label>
                <div class="custom-tags-container">
                  <input type="text" class="tag-input-style" placeholder="Type tag..." id="input-search"
                    (keyup)="onEnterKey($event)" />
                  <div class="tags-container d-flex flex-wrap gap-1 mt-1">
                    @for (tag of customTags; track tag; let i = $index) {
                    <span class="modern-tag-badge"
                      style="background-color: var(--bg-hover); padding: 4px 8px; font-size: 0.8rem;">
                      <span>{{ tag }}</span>
                      <button type="button" class="btn-remove-tag" (click)="removeCustomTag(i)">
                        <img src="../../../assets/close1.png" />
                      </button>
                    </span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- COLUMN 2: Media Upload Center (Right on desktop) -->
        <div class="media-column">
          <!-- Main Media Dropzone and Previews -->
          <div class="form-section">
            <div class="card-header-block">
              <h3 class="card-title-main">Upload Media</h3>
              <span class="file-info-text" id="upload-file" #uploadfile [style.display]="pdfDis"></span>
            </div>

            <div class="upload-card-wrapper">
              <!-- Image Preview -->
              @if(imageUrl && !showFilePlaceholder){
              <div class="media-preview-container">
                <img id="preview-image" class="imagePreview" [src]="imageUrl" />
              </div>
              }

              <!-- Video Preview -->
              @if (videoUrl) {
              <div class="media-preview-container">
                <video id="vd-main" class="videoPreview" controls [src]="videoUrl" type="video/mp4"></video>
              </div>
              }

              <!-- File/Doc Preview -->
              @if (imageUrl && showFilePlaceholder) {
              <div class="media-preview-container">
                <img id="preview-image" class="imagePreview" [src]="imageUrl" />
              </div>
              }

              <!-- Camera / Photo capture overlay elements -->
              <video id="vid2" class="hide" height="150px" controls></video>
              <canvas id="pic-canvas" class="hide"></canvas>
              <img id="pic-photo" class="hide takePhoto" alt="Screen Capture box" />

              <p class="hide" id="recorder-control" style="margin-top: 10px;">
                <button id="btnStart" class="btn-upload-secondary"
                  style="background: #ef4444; color: white; padding: 6px 12px; font-size: 0.8rem;">START
                  RECORDING</button>
                <button id="btnStop" class="btn-upload-secondary hide"
                  style="padding: 6px 12px; font-size: 0.8rem;">STOP RECORDING</button>
                <button id="btnKeep" (click)="keepRecording()" class="btn-upload-secondary hide"
                  style="padding: 6px 12px; font-size: 0.8rem;">SAVE</button>
              </p>

              @if (canvasDisplayImage) {
              <button id="startbutton" class="hide takePhoto btn btn-success" (click)="takePhoto()"
                style="margin-top: 5px; padding: 6px 12px; font-size: 0.8rem;">
                <i class="fa fa-camera"></i> Capture
              </button>
              }

              <!-- Standard Drop Zone UI -->
              @if (uploadSelection && !startPhoto && !previewVisible) {
              <div class="file-upload" (drop)="onFileDrop($event)" (dragover)="onDragOver($event)"
                id="file-uploadCamera" #fileUploadCamera>
                <img src="../../../assets/upload-icon.png" alt="upload-icon" class="upload-icon-style" />
                <p class="upload-main-text">Drag & drop files here</p>
                <p class="upload-sub-text">
                  Supported: JPEG, PNG, GIF, MP4, PDF, PSD, AI, Word, PPT
                </p>
                <div class="upload-btn-group">
                  <button type="button" class="btn-upload-primary" (click)="onClickUpload()">
                    Browse Files
                  </button>
                  <button type="button" class="btn-upload-secondary hide" (click)="onClickCamera()" id="camera-button"
                    #cameraButton>
                    Camera
                  </button>
                  <button type="button" class="btn-upload-secondary hide" (click)="onClickScreenCapture()"
                    id="screen-capture-button" #screenCaptureButton>
                    Screen
                  </button>
                </div>
              </div>
              }

              <input type="file" class="hide" id="upload-input" (change)="uploadMedia($event)" />

              <!-- Loading Spinner Block -->
              @if (barWidth == '100%' && !previewVisible) {
              <div class="lds-facebook mt-2">
                <div></div>
                <div></div>
                <div></div>
              </div>
              }
              @if ((barWidth == '100%' && !previewVisible) || messageError) {
              <div class="mt-2">
                <button class="btn btn-outline pleaseWait" style="font-size: 0.9rem;">
                  <span>Processing...</span>
                </button>
                <p class="text-danger font-12 mt-1">{{ messageError }}</p>
              </div>
              }
              @if (barWidth != '100%') {
              <div id="my-loader" #loadingBar class="hide" style="width: 100%; margin-top: 10px;">
                <div class="progress" style="height: 18px;">
                  <div class="bar" id="progressBar" #progressBar></div>
                </div>
                <div class="text-center mt-1 font-weight-bold" id="prog" #prog style="font-size: 0.8rem;">
                  {{ this.progress }}%
                </div>
              </div>
              }
            </div>

            <!-- Uploading Progress Loader Block -->
            @if (uploadInProgress) {
            <div class="uploading-progress-block mt-3 p-3" style="background: var(--bg-input, #0f172a); border-radius: 10px; border: 1px solid var(--border-color, rgba(255,255,255,0.15));">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <span style="font-size: 0.85rem; font-weight: 600; color: var(--text-primary); display: flex; align-items: center; gap: 8px;">
                  <i class="fa fa-spinner fa-spin text-primary"></i> Uploading in progress...
                </span>
                <span style="font-size: 0.85rem; font-weight: 700; color: var(--text-primary);">{{ barWidth }}</span>
              </div>
              <div class="progress" style="height: 10px; border-radius: 6px; background-color: rgba(255,255,255,0.1); overflow: hidden;">
                <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" role="progressbar"
                  [style.width]="barWidth" [attr.aria-valuenow]="barWidth" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>
            }

            <!-- Bottom Actions inside card if preview is active -->
            @if (previewVisible) {
            <div class="media-actions-bar">
              <span class="file-info-text text-truncate" id="upload-name" #uploadname
                style="max-width: 220px; font-size: 0.8rem;"></span>
              <button type="button" class="btn-remove-media" (click)="deleteMedia(id)" [disabled]="uploadInProgress"
                style="padding: 6px 12px; font-size: 0.8rem;">
                <i class="fa fa-trash"></i> Remove
              </button>
            </div>
            }
          </div>

          <!-- Video Thumbnail Selector (Only when video uploaded) -->
          @if (showThumbnail) {
          <div class="form-section separator-top">
            <div class="card-header-block">
              <h3 class="card-title-main">Video Thumbnail</h3>
            </div>

            <div class="img-show" style="padding: 10px;">
              <div class="sliderFixed">
                <div #swiperContainer class="swiper-container">
                  <div class="swiper-wrapper">
                    @for ( file of filesUrl; track file; let i = $index ) {
                    <div class="swiper-slide">
                      <div class="img-wrapper" (click)="onClickImage(file, i)">
                        <img [src]="file" class="thumbnail" />
                        <img class="thumbnailImg" [class.selected]="i === selectedImageIndex"
                          src="../../../assets/Group 26.png" style="width: 16px; height: 16px;" />
                      </div>
                    </div>
                    }
                  </div>

                  <div [ngClass]="{ 'visibility-hidden': !filesUrl?.length, 'visibility-shown': filesUrl?.length }"
                    class="swiper-pagination"></div>
                  <div [ngClass]="{ 'visibility-hidden': !filesUrl?.length, 'visibility-shown': filesUrl?.length }"
                    class="swiper-button-next"></div>
                  <div [ngClass]="{ 'visibility-hidden': !filesUrl?.length, 'visibility-shown': filesUrl?.length }"
                    class="swiper-button-prev"></div>
                </div>

                @if (thumbnailSpinner) {
                <div class="text-center py-2 text-muted w-100">
                  <p class="font-12 mb-0"><i class="fa fa-circle-o-notch fa-spin"></i> Generating...</p>
                </div>
                }
              </div>
            </div>
          </div>
          }
        </div>
      </div>

      <!-- Submit Action Row -->
      <div class="form-actions-row">
        <button type="button" class="btn-gradient-submit" (click)="onClickCollection()" [disabled]="uploadInProgress || archiveInProgress || !selectedFile">
          <i class="fa" [ngClass]="(uploadInProgress || archiveInProgress) ? 'fa-spinner fa-spin' : 'fa-save'"></i>
          <span>{{ (uploadInProgress || archiveInProgress) ? 'Uploading & Saving...' : 'Save' }}</span>
        </button>
      </div>
    </div>
  </div>
  }

  <!-- EDIT MODE BLOCK -->
  @if (edit) {
  <div class="container-fluid center">
    <div class="modern-card single-form-card">
      <div class="modern-grid-layout">

        <!-- COLUMN 1: Form Column (Left on desktop) -->
        <div class="form-column">
          <!-- General Information Card -->
          <div class="form-section">
            <div class="card-header-block">
              <h3 class="card-title-main">Asset Details</h3>
            </div>

            <form [formGroup]="projectForm" class="form-card-flow">
              <div class="modern-form-row">
                <div class="modern-form-group">
                  <label class="form-label-styled">Title</label>
                  <input class="modern-input-field" formControlName="title" type="text" placeholder="Enter title" />
                </div>

                <div class="modern-form-group">
                  <label class="form-label-styled">Client Name *</label>
                  <input class="modern-input-field" formControlName="client_name" type="text"
                    placeholder="Enter client name" />
                  @if (projectForm.get("client_name").invalid && projectForm.get("client_name").touched) {
                  <div class="text-danger font-12 mt-1">Client name is required.</div>
                  }
                </div>
              </div>

              <div class="modern-form-group">
                <div class="d-flex justify-content-between align-items-center mb-1">
                  <label class="form-label-styled mb-0">Description</label>
                  <span class="font-12 text-muted" [class.text-danger]="(projectForm.get('description')?.value?.length || 0) >= 1000">
                    {{ projectForm.get('description')?.value?.length || 0 }}/1000
                  </span>
                </div>
                <textarea class="modern-input-field modern-textarea-field" formControlName="description"
                  maxlength="1000" rows="5" placeholder="Write description here..."></textarea>
                @if (projectForm.get('description')?.hasError('maxlength')) {
                <div class="text-danger font-12 mt-1">Description cannot exceed 1000 characters.</div>
                }
              </div>
            </form>
          </div>

          <!-- Settings (Previously in top header) disabled in edit view -->
          <div class="form-section separator-top mouse-event-none">
            <div class="card-header-block">
              <h3 class="card-title-main">Collection Settings</h3>
            </div>

            <div class="settings-grid">
              <!-- Collection Type Toggle -->
              <div class="setting-item-box">
                <span class="setting-title">Collection Type</span>
                <div class="toggle-group-inline">
                  <span class="toggle-text-label"
                    [class.active-label]="selectedCollectionType === 'Public'">Public</span>
                  <div class="onoffswitch">
                    <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox" id="private-public"
                      [checked]="selectedCollectionType === 'Private'" (change)="onChangeCollectionType($event)" />
                    <label class="onoffswitch-label" for="private-public">
                      <span class="onoffswitch-switch"></span>
                    </label>
                  </div>
                  <span class="toggle-text-label"
                    [class.active-label]="selectedCollectionType === 'Private'">Private</span>
                </div>
              </div>

              <!-- Project Type Toggle -->
              <div class="setting-item-box">
                <span class="setting-title">Project Type</span>
                <div class="toggle-group-inline">
                  <span class="toggle-text-label"
                    [class.active-label]="selectedProjectType === 'Company'">Company</span>
                  <div class="onoffswitch">
                    <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox" id="projectType"
                      [checked]="selectedProjectType === 'Reference'" (change)="onChangeCompanyProductType($event)" />
                    <label class="onoffswitch-label" for="projectType">
                      <span class="onoffswitch-switch"></span>
                    </label>
                  </div>
                  <span class="toggle-text-label"
                    [class.active-label]="selectedProjectType === 'Reference'">Reference</span>
                </div>
              </div>

              <!-- Agreement Toggle -->
              <div class="setting-item-box">
                <span class="setting-title">Agreement</span>
                <div class="toggle-group-inline">
                  <span class="toggle-text-label" [class.active-label]="selectedAgreementType === 'NDA'">NDA</span>
                  <div class="onoffswitch">
                    <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox" id="nda"
                      [checked]="selectedAgreementType === 'Non-NDA'" (change)="onChangeNdaType($event)" />
                    <label class="onoffswitch-label" for="nda">
                      <span class="onoffswitch-switch"></span>
                    </label>
                  </div>
                  <span class="toggle-text-label"
                    [class.active-label]="selectedAgreementType === 'Non-NDA'">Non-NDA</span>
                </div>
              </div>

              <!-- Company Tabs selection -->
              <div class="setting-item-box">
                <span class="setting-title">Company</span>
                <div class="segmented-tabs-wrapper">
                  <button type="button" class="segmented-tab-btn" [class.active]="companyNameTag === 'square pixel'"
                    (click)="onChangeCompanyTag('square pixel')">
                    Square Pixel
                  </button>
                  <button type="button" class="segmented-tab-btn" [class.active]="companyNameTag === 'ink in caps'"
                    (click)="onChangeCompanyTag('ink in caps')">
                    Ink in Caps
                  </button>
                </div>
              </div>

              <!-- File Category Type selector -->
              <div class="setting-item-box full-width">
                <span class="setting-title">Category Type</span>
                <div class="modern-dropdown-wrapper dropdown">
                  <button class="btn dropdown-toggle modern-dropdown-btn" type="button" id="dropdownMenuButton"
                    data-toggle="dropdown" aria-expanded="false">
                    <span class="text-capitalize">{{ selectedTags }}</span>
                    <i class="fa fa-caret-down"></i>
                  </button>
                  <ul class="dropdown-menu modern-dropdown-menu" aria-labelledby="dropdownMenuButton">
                    @for ( tag of companyTagsArray[1].companyTags; track tag ) {
                    <li class="dropdown-item modern-dropdown-item text-capitalize" (click)="addCompanyRelatedTags(tag)">
                      {{ tag }}
                    </li>
                    }
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Edit mode: Additional Files Card -->
          <div class="form-section separator-top">
            <div class="card-header-block d-flex align-items-center justify-content-between">
              <h3 class="card-title-main mb-0">Additional Uploads</h3>
              <span class="badge badge-pill font-12 px-2 py-1" style="background: rgba(101, 101, 172, 0.2); color: var(--text-primary, #fff); border: 1px solid var(--border-color, rgba(255,255,255,0.15)); font-weight: 600;">
                Total Additional Files: {{ ImagefilesResponseUrl.length }}
              </span>
            </div>

            <div class="additional-files-grid">
              <label class="additional-add-btn" title="Add additional file">
                <input type="file" id="image-input" (change)="onClickAddImageEdit($event)" style="display: none" />
                <img src="../../../assets/icons 6/multiple-icon.png" width="20" height="20" />
                <span class="additional-upload-text">Click to upload additional assets</span>
              </label>

              @for (mediaUrl of ImagefilesResponseUrl; track mediaUrl; let i = $index) {
              <div class="additional-file-pill">
                <button type="button" class="close-button"
                  (click)="onClickDeleteImaEdited(mediaUrl._id, mediaUrl.mediaId)">
                  <img src="../../../assets/cross_icon.svg" />
                </button>

                @if (isImage(mediaUrl.fileUrl)) {
                <img class="additional-preview-thumb" [src]="mediaUrl.fileUrl" />
                }
                @if (isDocument(mediaUrl.fileUrl)) {
                <img class="additional-preview-thumb" [src]="getFileTypeImage(mediaUrl.fileUrl)" />
                }
                @if (isVideo(mediaUrl.fileUrl)) {
                <video class="additional-preview-thumb" [src]="mediaUrl.fileUrl"></video>
                }
                @if (mediaUrl.type === 'image') {
                <img class="additional-preview-thumb" [src]="mediaUrl.fileUrl" />
                }
                @if (mediaUrl.type === 'video') {
                <video class="additional-preview-thumb" [src]="mediaUrl.fileUrl"></video>
                }
              </div>
              }
            </div>

            @if (loading) {
            <div class="text-center py-1">
              <p class="font-12 mb-0 text-muted"><i class="fa fa-circle-o-notch fa-spin"></i> Uploading...</p>
            </div>
            }
          </div>

          <!-- Tagging & Group Organization Card in Edit -->
          <div class="form-section separator-top">
            <div class="card-header-block">
              <h3 class="card-title-main">Tagging & Organization</h3>
            </div>

            <div class="form-card-flow">
              <!-- Add to Collection -->
              <div class="modern-form-group">
                <label class="form-label-styled">Add to Collection</label>
                <div class="d-flex align-items-center flex-wrap gap-2">
                  <button type="button"
                    class="btn-upload-secondary btn-add-new-collection d-flex align-items-center gap-1"
                    data-toggle="modal" data-target="#staticBackdrop">
                    <img src="../../../assets/plus_icon.svg" width="12" height="12" />
                    <span>New</span>
                  </button>

                  <div class="modern-dropdown-wrapper dropdown flex-grow-1" style="max-width: 180px;">
                    <button class="btn dropdown-toggle modern-dropdown-btn" type="button" id="dropdownMenuButtonOpen"
                      data-toggle="dropdown" aria-expanded="false" (click)="addToExistingCollection()">
                      <span class="text-capitalize text-truncate">{{ selectedCollection || "Collection" }}</span>
                      <i class="fa fa-caret-down"></i>
                    </button>
                    <ul class="dropdown-menu modern-dropdown-menu" aria-labelledby="dropdownMenuButtonOpen"
                      style="max-height: 180px; overflow-y: auto;">
                      @for (group of existingCollections; track group; let i = $index) {
                      <li class="dropdown-item modern-dropdown-item text-capitalize" (click)="selectedPlayList(group)">
                        {{ group.title }}
                      </li>
                      }
                    </ul>
                  </div>

                  @if (collectionTags.length > 0) {
                  <span class="modern-tag-badge">
                    <span>{{ collectionTags }}</span>
                    <button type="button" class="btn-remove-tag" (click)="removeSelected(collectionTags)">
                      <img src="../../../assets/close1.png" />
                    </button>
                  </span>
                  }
                </div>
              </div>

              <!-- Primary auto tags -->
              <div class="modern-form-group mt-2">
                <label class="form-label-styled">Primary tags</label>
                <div class="tags-container d-flex flex-wrap gap-1">
                  @for (tag of primaryTags; track tag; let i = $index) {
                  <span class="modern-tag-badge primary-tag-badge">
                    <span>{{ tag }}</span>
                    @if (i > 3) {
                    <button type="button" class="btn-remove-tag" (click)="removePrimaryTag(i)">
                      <img src="../../../assets/close1.png" />
                    </button>
                    }
                  </span>
                  }
                </div>
              </div>

              <!-- Custom Tags -->
              <div class="modern-form-group">
                <label class="form-label-styled">Custom Tags (Enter)</label>
                <div class="custom-tags-container">
                  <input type="text" class="tag-input-style" placeholder="Type tag..." id="input-search"
                    (keyup)="onEnterKey($event)" />
                  <div class="tags-container d-flex flex-wrap gap-1 mt-1">
                    @for (tag of customTags; track tag; let i = $index) {
                    <span class="modern-tag-badge">
                      <span>{{ tag }}</span>
                      <button type="button" class="btn-remove-tag" (click)="removeCustomTag(i)">
                        <img src="../../../assets/close1.png" />
                      </button>
                    </span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- COLUMN 2: Media Edit Preview (Right on desktop) -->
        <div class="media-column">
          <!-- Media display card -->
          <div class="form-section">
            <div class="card-header-block">
              <h3 class="card-title-main">Asset Preview</h3>
              <span class="file-info-text" id="upload-file" #uploadfile [style.display]="pdfDis"></span>
            </div>

            <div class="upload-card-wrapper">
              @if (!changeFile) {
              <!-- Image display -->
              <img id="preview-image" #previewImage class="imagePreview" style="display: block;" />

              <!-- Folder placeholder -->
              @if (folderCheck) {
              <img id="preview-image1" class="imagePreview" src="../../../assets/book.webp" />
              }

              <!-- PDF Viewer -->
              @if (pdfUrl && pdfDisplay !== 'none') {
              <div class="doc-wrapper" [style.display]="pdfDisplay">
                <iframe id="pdf" #pdf [src]="pdfUrl" viewer="google" style="width: 100%; height: 260px; border: none;"
                  [style.display]="pdfDisplay"></iframe>
              </div>
              }

              <!-- Video Player -->
              <video title="Asset Video" id="preview-video"
                style="width: 100%; height: 260px; object-fit: contain; background-color: black; display: none;"
                controls></video>

              <!-- PDF embed fallback -->
              @if (pdfDisplay !== 'none') {
              <embed id="pdf" #pdf type="application/pdf" height="260px" width="100%" [style.display]="pdfDisplay" />
              }
              }

              @if (changeFile) {
              <img id="preview-image" #previewImage class="imagePreview" />
              @if (pdfUrl && pdfDisplay !== 'none') {
              <div class="doc-wrapper" [style.display]="pdfDisplay">
                <iframe id="pdf" #pdf [src]="pdfUrl" viewer="google" style="width: 100%; height: 260px; border: none;"
                  [style.display]="pdfDisplay"></iframe>
              </div>
              }
              <video id="preview-video" style="width: 100%; height: 100%; object-fit: contain; display: none;"
                controls></video>
              }

              <!-- Camera items (Required references for camera script) -->
              <video id="vid2" class="hide" height="150px" controls></video>
              <canvas id="pic-canvas" class="hide"></canvas>
              <img id="pic-photo" class="hide takePhoto" alt="Camera snap" />
              <p class="hide" id="recorder-control">
                <button id="btnStart" class="btn-upload-secondary">START RECORDING</button>
                <button id="btnStop" class="btn-upload-secondary hide">STOP RECORDING</button>
                <button id="btnKeep" (click)="keepRecording()" class="btn-upload-secondary hide">SAVE</button>
              </p>

              @if (canvasDisplayImage) {
              <button id="startbutton" class="hide takePhoto btn btn-success" (click)="takePhoto()">Take photo</button>
              }

              <!-- Fallback upload camera dropzone area in edit -->
              @if (uploadSelection && !startPhoto) {
              <div class="file-upload" (drop)="onFileDrop($event)" (dragover)="onDragOver($event)"
                id="file-uploadCamera" #fileUploadCamera>
                <img src="../../../assets/upload-icon.png" class="upload-icon-style" />
                <p class="upload-main-text">Drag & drop files or <span class="browse">Browse</span></p>
                <p class="upload-sub-text">Supported: JPEG, PNG, GIF, MP4, PDF, PSD, AI, Word, PPT</p>
                <div class="upload-btn-group">
                  <button type="button" class="btn-upload-primary" (click)="onClickUpload()">
                    Upload
                  </button>
                </div>
              </div>
              }

              <input type="file" class="hide" id="upload-input" (change)="uploadMedia($event)" />

              <!-- Loading Spinner in Edit -->
              @if (barWidth == '100%') {
              <div class="lds-facebook mt-2">
                <div></div>
                <div></div>
                <div></div>
              </div>
              }
              @if (barWidth == '100%' || messageError) {
              <div class="mt-2">
                <button class="btn btn-outline pleaseWait">
                  <span>Updating Asset</span>
                </button>
                <p class="text-danger font-12 mt-1">{{ messageError }}</p>
              </div>
              }
              @if (barWidth != '100%') {
              <div id="my-loader" #loadingBar class="hide" style="width: 100%; margin-top: 10px;">
                <div class="text-center font-weight-bold" id="prog" #prog style="font-size: 0.8rem;">0%</div>
                <div class="progress" style="height: 18px;">
                  <div class="bar" id="progressBar" #progressBar></div>
                </div>
              </div>
              }
            </div>

            <!-- Edit info actions -->
            <div class="media-actions-bar text-center"
              style="padding: 10px; width: 100%; display: flex; justify-content: center; align-items: center;">
              <span class="file-info-text text-truncate edit-upload-name" id="upload-name" #uploadname></span>
            </div>
          </div>

          <!-- Thumbnail selector (if filesUrl lists exist in edit mode) -->
          @if (filesUrl.length > 0 || thumbnailSpinner) {
          <div class="form-section separator-top">
            <div class="card-header-block">
              <h3 class="card-title-main">Asset Thumbnails</h3>
            </div>
            <div class="img-show" style="padding: 10px;">
              <div class="sliderFixed">
                @if (thumbnailSpinner) {
                <div class="text-center py-2 text-muted w-100">
                  <p class="font-12 mb-0"><i class="fa fa-circle-o-notch fa-spin"></i> Rendering...</p>
                </div>
                }
              </div>
            </div>
          </div>
          }
        </div>
      </div>

      <!-- Submit Edit -->
      <div class="form-actions-row">
        <button type="button" class="btn-gradient-submit" (click)="onClickCollectionEdit(false)"
          [disabled]="uploadInProgress || archiveInProgress">
          <i class="fa" [ngClass]="(uploadInProgress || archiveInProgress) ? 'fa-spinner fa-spin' : 'fa-save'"></i>
          <span>{{ (uploadInProgress || archiveInProgress) ? 'Saving...' : 'Save Changes' }}</span>
        </button>
      </div>
    </div>
  </div>
  }
</div>

<!-- Add New Collection Modal -->
<div class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="staticBackdropLabel">
          Add A New Collection
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <img src="../../../assets/cross_icon.svg" alt="close" style="width: 14px; height: 14px;" />
        </button>
      </div>

      <div class="modal-body text-left">
        <div>
          <label for="collection" class="form-label-styled">
            Collection Title:
          </label>
          <input type="text" class="form-control modern-input-field mb-3 collection-input"
            [(ngModel)]="collectionTitle" />
        </div>

        <span class="form-label-styled mb-2">Type:</span>
        <div class="toggle-group-inline mt-2">
          <label class="cursorPointer d-flex align-items-center mr-4">
            <input type="radio" name="collectionType" value="Public" [(ngModel)]="selectedCollectionType" />
            <span class="toggle-text-label pl-2">Public</span>
          </label>

          <label class="cursorPointer d-flex align-items-center">
            <input type="radio" name="collectionType" value="Private" [(ngModel)]="selectedCollectionType" />
            <span class="toggle-text-label pl-2">Private</span>
          </label>
        </div>
      </div>

      <div class="modal-footer justify-content-center">
        <button (click)="createCollection()" type="button" class="btn btn-warning fw-collection-modal"
          data-dismiss="modal">
          Create
        </button>
      </div>
    </div>
  </div>
</div>